import { ca } from '@cian/analytics';

export function trackCreditFullPriceClick(isBankMortgage: boolean) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card',
    action: 'click_info',
    label: 'open_loan_full_price_info',
    useLastProducts: true,
    page: {
      extra: {
        source: 'different_price',
        is_bank_mortgage: isBankMortgage,
      },
    },
  });
}
